import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "common",
  initialState: () => {
    return {loading: false, navIndex: 0, showUserPopup: false, message: null};
  },
  reducers: {
    setLoading: (state, action) => {
      //console.log("reducers setLoading "+action.payload.loading);
      state.loading = action.payload.loading;
    },
    showMessage: (state, action) => {
      //console.log("reducers showMessage "+action.payload.message);
      state.message = action.payload.message;
      // setTimeout(()=>state.message = null, 2000)
    },
    setNavIndex: (state, action) => {
      //console.log("reducers setNavIndex "+action.payload.navIndex);
      state.navIndex = action.payload.navIndex;
    },
    setShowUserPopup: (state, action) => {
      // console.log("reducers setShowUserPopup "+action.payload.showUserPopup);
      state.showUserPopup = action.payload.showUserPopup;
    }
  }
});

export const { setLoading, showMessage, setNavIndex, setShowUserPopup } = commonSlice.actions;

export default commonSlice.reducer;

export const isLoading = (state) => state?.common?.loading;
export const getMessage = (state) => state?.common?.message;
export const getNavIndex = (state) => state?.common?.navIndex;
export const isShowUserPopup = (state) => state?.common?.showUserPopup;